import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import ListPagination from '../../../../../components/UI/ListPaginationUl';
import BackButton from '../../../../../components/UI/BackButton';
import { TitleUI } from '../../../../../components/UI/LabelTitleUI';
import { translate, formatData, getUserNameToName } from "../../../../../utils/util";

const ListItemKanban = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [data, setData] = useState([]);
    const [ordernacaoItem, setOrdernacaoItem] = useState(false);

    useEffect(() => {
        const items = props.location?.state?.data;
        if (items) {
            setData(items.sort((a, b) => {
                return new Date(a.date) - new Date(b.date);
            }))
        }
        // eslint-disable-next-line
    }, []);

    const ordernar = (status) => {
        const array = [];
        Object.assign(array, data);
        setOrdernacaoItem(status);
        setData(array.sort((a, b) => {
            if (status) {
                return new Date(b.date) - new Date(a.date);
            }
            else {
                return new Date(a.date) - new Date(b.date);
            }
        }));
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <TitleUI icon="mdi mdi-developer-board" label={translate('line-picking:linepicking.kanban')} />
                </div>
            </div>
            <div className="title" style={{ float: 'right', margin: '5px' }}>
                <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => ordernar(ordernacaoItem ? false : true)}>{'swap_vert'}</i>
            </div>
            <div className="container-fluid" style={{ marginTop: '0px' }}>
                <div id="ListItemKanban">

                    <ListPagination
                        page={0}
                        current={{ currentPage, setCurrentPage }}
                        data={data.map((item) => (

                            <div
                                className="row"
                                style={{ display: 'block', marginBottom: '0px', marginLeft: '5px' }}
                            >
                                <span className="title sixth-text-color" style={{ marginLeft: '10px', display: 'block' }} >
                                    {`${item.orderCode} - ${item.items[0]?.orderItemCode}`}
                                </span>
                                <span className="title sixth-text-color" style={{ marginLeft: '10px', display: 'block' }} >
                                    {`${item.items[0].partnumber || ''}`}
                                </span>
                                <span className="title sixth-text-color" style={{ marginLeft: '10px', display: 'block' }} >
                                    {item.route?.code || ""}
                                </span>
                                <span className="title sixth-text-color" style={{ marginLeft: '10px', display: 'block' }} >
                                    {getUserNameToName(props?.usersFromElog, item.username) || ""}
                                </span>
                                <span className="title sixth-text-color" style={{ marginLeft: '10px', display: 'block' }} >
                                    {formatData(item.date)}
                                </span>

                            </div>
                        ))}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListItemKanban)));
